import React, { useState, useContext, useEffect, useRef } from 'react';
import { GameDataContext } from '../providers/GameDataProvider';
import Minimap from './Minimap';
import Events from './Events';
import Scoreboard from './Scoreboard';
import TimelineControlBar from './TimelineControlBar';
import PerformanceSummary from './PerformanceSummary';
import { getAggregatedEvents } from '../utils/utils';
import WinrateContributionRanks from './WinrateContributionRanks';
import Matchup from './Matchup';
var Timeline = function () {
    var gameData = useContext(GameDataContext);
    var scrollContainerRef = useRef(null);
    var _a = useState(0), index = _a[0], setIndex = _a[1];
    var _b = useState([]), selectedIndexes = _b[0], setSelectedIndexes = _b[1];
    var aggEvents = getAggregatedEvents(gameData.events);
    var teamAggWinrateDiffs = aggEvents.map(function (aggEvent) { return aggEvent.reduce(function (acc, event) { return acc + event.winrateDiff; }, 0); });
    var playerAggWinrateDiffs = aggEvents.map(function (aggEvent) { return aggEvent.reduce(function (acc, event) { return (event.participantChampionNames.includes(gameData.playerChampion) && event.participantTeam === gameData.playerTeam) || (event.victimName === gameData.playerChampion && event.victimTeam === gameData.playerTeam) ? acc + event.winrateDiff : acc; }, 0); });
    useEffect(function () {
        var scrollContainer = scrollContainerRef.current;
        var handleWheel = function (event) {
            event.preventDefault();
            if (event.deltaY > 0) {
                setIndex(function (index) { return Math.min(gameData.snapshots.length - 1, Math.max(0, index + 1)); });
            }
            else {
                setIndex(function (index) { return Math.min(gameData.snapshots.length - 1, Math.max(0, index - 1)); });
            }
        };
        scrollContainer.addEventListener('wheel', handleWheel);
        return function () {
            scrollContainer.removeEventListener('wheel', handleWheel);
        };
    }, []);
    return (React.createElement("div", { style: { width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' } },
        React.createElement("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 80 } },
            React.createElement("div", { style: { width: 220, height: 300 } },
                React.createElement(WinrateContributionRanks, null)),
            React.createElement("div", { style: { width: 100, height: '100%', marginTop: 30, marginBottom: 75 } },
                React.createElement(Matchup, null)),
            React.createElement("div", { style: { width: 260, marginBottom: 75, marginLeft: -30, marginRight: -30 } },
                React.createElement(PerformanceSummary, { selectedIndexes: selectedIndexes, setSelectedIndexes: setSelectedIndexes, winrateDiffs: teamAggWinrateDiffs, title: "Your Team" })),
            React.createElement("div", { style: { width: 260, marginBottom: 75, marginLeft: -30, marginRight: -30 } },
                React.createElement(PerformanceSummary, { selectedIndexes: selectedIndexes, setSelectedIndexes: setSelectedIndexes, winrateDiffs: playerAggWinrateDiffs, title: "You" }))),
        React.createElement(Events, { setIndex: setIndex, selectedIndexes: selectedIndexes }),
        React.createElement("div", { ref: scrollContainerRef, style: { width: '100%', height: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', overflowX: 'auto', marginTop: 55, paddingTop: 20, userSelect: 'none' } },
            React.createElement("div", { style: { marginLeft: 'auto', paddingLeft: '4%' } },
                React.createElement(Minimap, { i: index })),
            React.createElement("div", { style: { marginLeft: 50, marginRight: 'auto', minWidth: 995, height: 500 * 1.08, display: 'flex', flexDirection: 'column', alignSelf: 'center' } },
                React.createElement(Scoreboard, { i: index }),
                React.createElement(TimelineControlBar, { i: index, setIndex: setIndex })))));
};
export default Timeline;
